import { css, SerializedStyles } from '@emotion/core'
import styled from '@emotion/styled'

import { transientOptions } from '../../constants/transientOptions'
import { BorderRadius } from '../../enums/borderRadius'
import { getDefaultTransition } from '../../utils/getDefaultTransition'
import { TagColor, TagSize, TagType } from './types'
import { getColorStyle } from './utils/getColorStyle'
import { getDisabledStyle } from './utils/getDisabledStyle'
import { getSelectedStyle } from './utils/getSelectedStyle'
import { getSizeStyle } from './utils/getSizeStyle'

interface TagWrapperProps {
  $tagType: TagType
  $tagColor: TagColor
  $tagSize: TagSize
  $clickable: boolean
  $disabled: boolean
  $maxWidth?: string
  $selected: boolean
}

export const TagWrapper = styled('span', transientOptions)<TagWrapperProps>`
  display: inline-flex;
  align-items: center;
  max-width: ${({ $maxWidth }) => $maxWidth || 'none'};
  border-width: 1px;
  border-style: solid;
  border-radius: ${BorderRadius.R8};
  white-space: nowrap;
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
  ${getDefaultTransition('background-color', 'border-color', 'color')};

  ${({ $tagSize }) => getSizeStyle($tagSize)};

  ${({ $tagType, $tagColor, $clickable, $disabled, $selected }): SerializedStyles => {
    if ($disabled) {
      return getDisabledStyle($tagColor)
    }
    if ($selected) {
      return css`
        ${getColorStyle($tagType, $tagColor, $clickable)};
        ${getSelectedStyle($tagType, $tagColor)};
      `
    }
    return getColorStyle($tagType, $tagColor, $clickable)
  }};
`

export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
  border: none;
  background: none;
  color: inherit;
  line-height: 0;
  cursor: pointer;
`
